import {atom} from "recoil";

const loadingState = atom({
  key: 'alarm_detail_loading',
  default: true
})

const errorState = atom({
  key: 'alarm_detail_error',
  default: false
})

const alarmState = atom({
  key: 'alarm_detail_alarm',
  default: {}
})

export {
  loadingState,
  errorState,
  alarmState
}